import ReactOnRails from 'react-on-rails';
import LocalTime from "local-time"
import NavBar from '../bundles/layout/NavBar';
import CopyWidget from '../bundles/widgets/CopyWidget';
import PasteWidget from '../bundles/widgets/PasteWidget';
import mixpanel from "mixpanel-browser";

window.mixpanelToken = document.querySelector('meta[name="mixpanel"]').getAttribute('content');
mixpanel.init(window.mixpanelToken);

ReactOnRails.register({
  NavBar,
  CopyWidget,
  PasteWidget,
});
LocalTime.start();

import jquery from "jquery";
window.jQuery = jquery;
window.$ = jquery;

$(function () {
  const trackableLinks = $('.trackable-link');
  $(trackableLinks).on("click", function (e) {
    const linkText = e.currentTarget.dataset.linkText;
    const text = e.currentTarget.text;
    mixpanel.track(`Click link "${linkText || text}"`);
  });
});

$('#home-index-healthie-btn, #appointments-index-healthie-btn, #patient-portal-healthie-btn').on('click', function (e) {
  e.preventDefault()

  const { currentTarget } = e;
  const tagId = currentTarget.id;
  const contentName = tagId === 'patient-portal-healthie-btn' ? "healthie-patient-portal" : "healthie-appointment-scheduler"
  const jqueryTarget = $(currentTarget);

  ttq.identify({
    "external_id": jqueryTarget.data("userId") // string. Any unique identifier, such as loyalty membership IDs, user IDs, and external cookie IDs.It must be hashed with SHA-256 on the client side.
  });

  ttq.track('AddToCart', {
    "contents": [
      {
        "content_id": tagId, // string. ID of the product. Example: "1077218".
        "content_type": "product", // string. Either product or product_group.
        "content_name": contentName // string. The name of the page or product. Example: "shirt".
      }
    ]
  }, {
    "event_id": jqueryTarget.data("dateTime") // string. A hashed ID that can identify a unique event. Example: "1616318632825_357".
  });

  window.location.href = currentTarget.href;
});